import { action } from '@reatom/framework'

import { pipe, Result } from '@blade/std-lib'
import { ApiError, apiRequest } from '@root/shared/api'
import { tradeApiClientAtom } from '@root/shared/api/trade-api-client-atom'

import { LeaderboardEntry } from '../model'

export const fetchTradingLeaderboardRequestAction = action(
  async (
    ctx,
    {
      limit,
      offset,
    }: {
      limit: number
      offset: number
    },
  ) => {
    const { tradeApiClient } = ctx.get(tradeApiClientAtom)
    const result = await ctx.schedule(() =>
      apiRequest(ctx, tradeApiClient.leaderboard.leaderboardTradeList, [
        {
          limit: limit,
          offset: offset,
        },
      ]),
    )

    const mappedResult = pipe(
      result,
      Result.map((it) => it.map(LeaderboardEntry.tradeEntryFromDto)),
      Result.mapError(ApiError.fallbackToUnknown),
    )
    return mappedResult
  },
  'fetchTradingLeaderboardRequestAction',
)

export const fetchReferralLeaderboardRequestAction = action(
  async (
    ctx,
    {
      limit,
      offset,
    }: {
      limit: number
      offset: number
    },
  ) => {
    const { tradeApiClient } = ctx.get(tradeApiClientAtom)

    const result = await ctx.schedule(() =>
      apiRequest(ctx, tradeApiClient.leaderboard.leaderboardReferralList, [
        {
          limit: limit,
          offset: offset,
        },
      ]),
    )

    const mappedResult = pipe(
      result,
      Result.map((it) => it.map(LeaderboardEntry.referralEntryFromDto)),
      Result.mapError(ApiError.fallbackToUnknown),
    )
    return mappedResult
  },
  'fetchReferralLeaderboardRequestAction',
)
